/**
 * A file's size the way the Figma's upload card reads it ("48 MB"), in
 * decimal units like iOS Photos. Null when unknown (a video uploaded before
 * sizes were kept, or a picker that didn't say).
 */
export function formatFileSize(bytes?: number | null): string | null {
  if (!bytes || bytes <= 0) return null;
  if (bytes >= 1e9) return `${(bytes / 1e9).toFixed(1)} GB`;
  if (bytes >= 1e6) return `${Math.round(bytes / 1e6)} MB`;
  return `${Math.max(1, Math.round(bytes / 1e3))} KB`;
}
